// extracted by mini-css-extract-plugin
module.exports = {"item":"ApprovalItem__item--1rhIJ","selected":"ApprovalItem__selected--3I3qt","approvalItemLink":"ApprovalItem__approvalItemLink--2RqEv"};